import type { FaireProductEntity } from "../../entity_types/product";

export const p_jbhncvnhwy: FaireProductEntity = {
  token: "p_jbhncvnhwy",
  type: "product",
  name: "925 Silver Marquise & Round Moissanite Eternity Band",
  brandToken: "b_mpb8yp79mh",
  brandName: "GEMPARA",
  imageUrl:
    "https://cdn.faire.com/fastly/3c49fdea5aef560924d95fc7fa52703844417949a6f8ff10d050bd6f77c1b9a5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/299136784a48a676619793818e98f77deb38434362bcdab6f1a803c3d9da8e0a.png",
    "https://cdn.faire.com/fastly/b4e388551187470b05c12a529d387e9ae2c44fc9a048561e969d1208759c3514.jpeg",
    "https://cdn.faire.com/fastly/b44b6a1753a804f3fd23ecbbf83b9ecff68ae8d13e962f4d598bf382f3cac132.jpeg",
  ],
  priceDollars: 20.77,
  description:
    "Timeless brilliance meets delicate craftsmanship in this moissanite eternity band. Each marquise and round-cut stone is meticulously set in a continuous pattern that symbolizes infinite love and grace. Handcrafted in solid 925 sterling silver, this ring radiates with quiet luxury — perfect for stacking, pairing with engagement rings, or wearing solo as a refined statement of elegance.\n\nDetails\n\nMetal: 925 Sterling Silver\n\nStone: Moissanite (Lab-Grown, Conflict-Free)\n\nCut: Marquise & Round Mixed\n\nBand Width: 2.5 mm",
  tags: [],
  msrpDollars: 41.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:59.048Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
